.er{width:1rem;}